import { isRunningStatus } from '@agilelab/plugin-wb-builder-common';
import { FC, useEffect, useMemo } from 'react';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { AssistantDrawer } from './AssistantDrawer/AssistantDrawer';
import { AsyncTestTableRow } from './AsyncTestTableRow';
import { TaskDrawer } from './TaskDrawer/TaskDrawer';
import { TestCurrentEmptyState } from './TestCurrentEmptyState';
import { TestCurrentRow } from './TestCurrentRow';
import { TestTableLoading } from './TestTableLoading';
import { TestTableLoadingRow } from './TestTableLoadingRow';

export const TestCurrent: FC = () => {
  const {
    selectedTask,
    setSelectedTask,
    showCurrentTest,
    lastTestState,
    descriptorStateWithComponents,
    environment,
    monacoEditorRef,
    fetchAssistant,
    testLoading,
  } = useEditorPageContext();

  useEffect(() => {
    fetchAssistant();
  }, [fetchAssistant]);

  const isRunning = useMemo(() => {
    return (
      lastTestState.value &&
      (isRunningStatus(lastTestState.value.status) ||
        lastTestState.value.tasks.some(task => isRunningStatus(task.status)))
    );
  }, [lastTestState.value]);

  return (
    <>
      {(!lastTestState.value ||
        !showCurrentTest ||
        lastTestState.value?.environment !== environment) &&
        !testLoading && <TestCurrentEmptyState />}
      {isRunning && lastTestState.value && (
        <AsyncTestTableRow test={lastTestState.value} />
      )}
      {testLoading && (
        <TestTableLoading>
          <TestTableLoadingRow
            isLoading
            loadingText={
              descriptorStateWithComponents.loading
                ? 'Fetching the descriptor'
                : 'Validating the descriptor'
            }
          />
        </TestTableLoading>
      )}
      {!testLoading && lastTestState.value && (
        <TestTableLoading>
          {lastTestState.value && <TestCurrentRow test={lastTestState.value} />}
        </TestTableLoading>
      )}
      <TaskDrawer
        task={selectedTask}
        open={Boolean(selectedTask)}
        onClose={() => {
          setSelectedTask(null);
          monacoEditorRef.current?.applyDecorations(
            undefined,
            undefined,
            'white',
          );
        }}
      />
      <AssistantDrawer />
    </>
  );
};
